import { Offcanvas } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import { MdOutlineCategory } from "react-icons/md";
import { MdOutlineRestore } from "react-icons/md";

const DeletedGroups = ({
  Show,
  Hide,
  Title,
  deleteGroup,
  deletedGroupList,
  softDeleteRestoreGroup,
  isDark
}) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {deletedGroupList?.map((g) => (
          <div key={g.groupId} className="hstack justify-content-between mb-2">
            <span style={{ fontSize: 14 }} className="hstack gap-2"><MdOutlineCategory /> {g.groupName}</span>
            <div className="hstack gap-3">
              <MdOutlineRestore
                title="Restore Group"
                style={{ fontSize: 16 }}
                className="text-success CP"
                onClick={() => softDeleteRestoreGroup(g.groupId, "restore")}
                />
              <FaTrash
                title="Permanent Deleted Group"
                style={{ fontSize: 12 }}
                className="text-danger CP"
                onClick={() => deleteGroup(g.groupId)}
              />
            </div>
          </div>
        ))}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DeletedGroups;
